var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rules-container"},[_c('h1',[_vm._v("RULES")]),_c('Options',{attrs:{"rules":_vm.rules}}),_c('a',{on:{"click":_vm.handleCloseRules}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }